export default __webpack_public_path__ + "static/media/arrow_right.64126fc1.svg";